export default {
      id: "icon--corporate-usage",
      viewBox: "0 0 32 28",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--corporate-usage",
      toString: function () {
        return this.url;
      }
    }